exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point-num[data-v-5c8b515c]{font-size:1.8rem}", ""]);

// exports
